//TODO move data to seperate file
//TODO move data to database
const locationDefaults = {
    locations: {
        novatoMonday: {
            displayName: 'Novato Teen Clinic (Mondays)',
            address: '6090 Redwood Blvd, Novato, CA 94945',
            appointment: 'Drop-In',
            phone: '(415) 898-1100',
            openingTimes: [
                ["Sunday"],
                ["Monday"],
                ["Tuesday", 13.00, 17.00],
                ["Wednesday"],
                ["Thursday"],
                ["Friday"],
                ["Saturday"]
            ],
            price: '0',
            locationType: 'free clinic',
            takesFpact: 'true',
            moreInfoLink: 'https://www.northmarincs.org/programs/counseling-and-therapy/novato-teen-clinic/'
        },
        huckleberry: {
            displayName: 'Huckleberry Teen Tuesday Clinic',
            address: '361 3rd St G, San Rafael, CA 94901',
            appointment: 'Drop-In',
            phone: '(415) 258-4944',
            openingTimes: [
                ["Sunday"],
                ["Monday", 13.30, 17.00],
                ["Tuesday"],
                ["Wednesday"],
                ["Thursday"],
                ["Friday"],
                ["Saturday"]
            ],
            price: '0',
            locationType: 'free clinic',
            takesFpact: 'true',
            moreInfoLink: 'https://www.facebook.com/Teen-Tuesday-at-Huckleberry-Youth-Programs-107338412685599/'
        },
        plannedParenthood: {
            displayName: 'Planned Parenthood - San Rafael',
            address: '2 H St, San Rafael, CA 94901',
            appointment: 'Appt or Drop-In',
            phone: '(415) 459-4907',
            openingTimes: [
                ["Sunday"],
                ["Monday", 8.30, 17.00],
                ["Tuesday", 8.30, 17.00],
                ["Wednesday", 11.30, 20.00],
                ["Thursday", 8.30, 17.00],
                ["Friday", 8.00, 16.30],
                ["Saturday"]
            ],
            price: '0',
            locationType: 'pharmacy, free clinic',
            takesFpact: 'true',
            moreInfoLink: 'https://www.facebook.com/Teen-Tuesday-at-Huckleberry-Youth-Programs-107338412685599/'
        },
        kaiser: {
            displayName: 'Kaiser - Downtown San Rafael Pharmacy',
            address: '1033 3rd St., San Rafael, CA 94901',
            appointment: 'Drop-In',
            phone: '415-482-6800',
            openingTimes: [
                ["Sunday"],
                ["Monday", 9.00, 18.00],
                ["Tuesday", 9.00, 18.00],
                ["Wednesday", 9.00, 18.00],
                ["Thursday", 9.00, 18.00],
                ["Friday", 9.00, 18.00],
                ["Saturday"]
            ],
            price: '$0 - $25',
            locationType: 'pharmacy',
            takesFpact: 'true',
            moreInfoLink: 'https://thrive.kaiserpermanente.org/care-near-you/northern-california/sanrafael/departments/downtown-san-rafael-medical-offices-pharmacy/'
        },
        riteAid: {
            displayName: 'Rite Aid',
            address: '471 3rd St, San Rafael, CA 94901',
            appointment: 'Drop-In',
            phone: '(415) 454-7744',
            openingTimes: [
                ["Sunday", 10.00, 18.00],
                ["Monday", 9.00, 21.00],
                ["Tuesday", 9.00, 21.00],
                ["Wednesday", 9.00, 21.00],
                ["Thursday", 9.00, 21.00],
                ["Friday", 9.00, 21.00],
                ["Saturday", 9.00, 18.00]
            ],
            price: '$25 - $60',
            locationType: 'pharmacy, pregnancy',
            takesFpact: 'false',
            moreInfoLink: 'https://locations.riteaid.com/locations/ca/san-rafael/471-3rd-street.html'
        },
        target: {
            displayName: 'Target',
            address: '125 Shoreline Pkwy, San Rafael, CA 94901',
            appointment: 'Drop-In',
            phone: '(415) 454-7744',
            openingTimes: [
                ["Sunday"],
                ["Monday", 8.00, 23.00],
                ["Tuesday", 8.00, 23.00],
                ["Wednesday", 8.00, 23.00],
                ["Thursday", 8.00, 23.00],
                ["Friday", 8.00, 23.00],
                ["Saturday", 8.00, 23.00]
            ],
            price: '$25 - $60',
            locationType: 'pharmacy, pregnancy',
            takesFpact: 'false',
            moreInfoLink: 'https://www.target.com/sl/San-Rafael--Target-Store/2772'
        },
        walgreens: {
            displayName: 'Walgreens',
            address: '830 3rd Street, San Rafael, CA 94901',
            appointment: 'Drop-In',
            phone: '(415) 455-9919',
            openingTimes: [
                ["Sunday", 10.00, 18.00],
                ["Monday", 8.00, 21.00],
                ["Tuesday", 8.00, 21.00],
                ["Wednesday", 8.00, 21.00],
                ["Thursday", 8.00, 21.00],
                ["Friday", 8.00, 21.00],
                ["Saturday", 9.00, 18.00]
            ],
            price: '$25 - $60',
            locationType: 'pharmacy, pregnancy',
            takesFpact: 'false',
            moreInfoLink: 'https://www.walgreens.com/locator/walgreens-830+3rd+st-san+rafael-ca-94901/id=4625'
        },
        cvs: {
            displayName: 'CVS - Grand Ave',
            address: '909 Grand Ave, San Rafael, CA 94901',
            appointment: 'Drop-In',
            phone: '(415) 897-4171',
            openingTimes: [
                ["Sunday", 10.00, 18.00],
                ["Monday", 9.00, 21.00],
                ["Tuesday", 9.00, 21.00],
                ["Wednesday", 9.00, 21.00],
                ["Thursday", 9.00, 21.00],
                ["Friday", 9.00, 21.00],
                ["Saturday", 10.00, 18.00]
            ],
            price: '$30 - $60',
            locationType: 'pharmacy, pregnancy',
            takesFpact: 'false',
            moreInfoLink: 'https://www.cvs.com/store-locator/details-directions/4952'
        },
        marinCCSanRafael: {
            displayName: 'Marin Community Clinics - San Rafael',
            address: '3110 Kerner Boulevard, San Rafael, CA 94901',
            appointment: 'Appt or Drop-In',
            phone: '(415) 448-1500',
            openingTimes: [
                ["Sunday"],
                ["Monday", 8.00, 19.00],
                ["Tuesday", 8.00, 19.00],
                ["Wednesday", 8.00, 19.00],
                ["Thursday", 8.00, 19.00],
                ["Friday", 8.00, 19.00],
                ["Saturday", 8.00, 16.00]
            ],
            price: '$20 - $60',
            locationType: 'pharmacy',
            takesFpact: 'true',
            moreInfoLink: 'http://www.marinclinic.org/'
        },
        marinCCLarkspur: {
            displayName: 'Marin Community Clinics - Larkspur',
            address: '5 Bon Air Road, Bldg. D, Suite 117, Larkspur, CA 94939',
            appointment: 'Appt or Drop-In',
            phone: '(415) 448-1500',
            openingTimes: [
                ["Sunday"],
                ["Monday", 8.00, 17.00],
                ["Tuesday", 8.00, 17.00],
                ["Wednesday", 8.00, 17.00],
                ["Thursday", 8.00, 17.00],
                ["Friday", 8.00, 17.00],
                ["Saturday"]
            ],
            price: '$20 - $60',
            locationType: 'pharmacy',
            takesFpact: 'true',
            moreInfoLink: 'http://www.marinclinic.org/'
        },
        marinCCLarkspur: {
            displayName: 'Marin Community Clinics - South Novato',
            address: '6090 Redwood Boulevard, Novato, CA 94945',
            appointment: 'Appt or Drop-In',
            phone: '(415) 448-1500',
            openingTimes: [
                ["Sunday"],
                ["Monday", 8.30, 11.30],
                ["Tuesday", 8.30, 11.30],
                ["Wednesday", 8.30, 11.30],
                ["Thursday", 8.30, 11.30],
                ["Friday", 8.30, 11.30],
                ["Saturday", 13.30, 17.00]
            ],
            price: '$20 - $60',
            locationType: 'pharmacy',
            takesFpact: 'true',
            moreInfoLink: 'http://www.marinclinic.org/'
        },
    },
    filteredList: {}
}

const locationsReducer = (state = locationDefaults, action) => {
    switch (action.type) {
        case 'GET_LOCATIONS_LIST': {
            let list = {};

            for (var key in state.locations) {
                if (state.locations.hasOwnProperty(key)) {
                    if (state.locations[key].locationType.includes(action.payload)) {
                        list[key] = state.locations[key];
                    }
                }
            }
            return { ...state, filteredList: list }
        }

        case 'GET_FPACT_LIST': {
            let list = {};

            for (var key in state.locations) {
                if (state.locations.hasOwnProperty(key)) {
                    if (state.locations[key].takesFpact == action.payload
                        && state.locations[key].locationType == 'pharmacy') {
                        list[key] = state.locations[key];
                    }
                }
            }
            return { ...state, filteredList: list }
        }
    }

    return state;
}

export default locationsReducer;


// WEBPACK FOOTER //
// ./src/reducers/locations.js